<template>
    <div class="AllOrder" style="" id="homeBox">

        <!--        订单状态筛选部分-->
        <div class="title"  style="font-size: 14px">
            <span class="titlew" >任务状态</span>
            <el-select @change="statusch" size="mini" clearable v-model="searchdata.status" slot="prepend" placeholder="全部" class="titlew" style="color:black;width: 150px;">
                <el-option v-for="val in zhuangcode" :key="val.status" :label="val.vc_status" :value="val.status"></el-option>

            </el-select>
            <span class="titlew" >任务日期</span>
            <el-date-picker size="mini" style="width: 150px"
                            v-model="searchdata.startTime"
                            type="date"
                            placeholder="开始日期"
                            value-format="yyyy-MM-dd"
                            clearable
            >
            </el-date-picker>
            <span class="titlew" >至</span>
            <el-date-picker size="mini" style="width: 150px "
                            v-model="searchdata.endTime"
                            type="date"
                            clearable
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期"
            >
            </el-date-picker>
            <span style="padding: 0 10px 0 15px">分厂</span>
            <el-select clearable size="mini" @clear="bmclear" :filter-method="bmfilter" @change="bmchange" v-model="searchdata.bmName" filterable placeholder="请选择">
                <el-option
                        v-for="item in bmdata"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

            <span style="padding: 0 10px 0 15px">工段</span>

            <el-select clearable size="mini" :filter-method="cjfilter" @change="cjchange"  v-model="searchdata.cjName" filterable placeholder="请选择">
                <el-option
                        v-for="item in cjdata"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
            <span style="padding: 0 10px 0 15px">班次</span>
            <div  >
                <el-select @focus="bcclick" clearable v-model="searchdata.bc"　size="mini" placeholder="请选择" style="color:black;padding: 0 10px 0 5px;width: 150px;">
                    <el-option v-for="(val,index) in types" :key="index" :label="val.bcName" :value="val.positionTime"></el-option>
                </el-select>
            </div>


            <el-input  size="mini" clearable v-model="searchdata.all" placeholder="请输入搜索内容" style="height: 39px;width: 200px;line-height: 39px"></el-input>
            <button size="mini" style="background-color: #eed671;font-weight: bold;color: black;width: 60px;height: 39px;text-align: center;border:0;margin-left: 15px"  @click="find()">搜索</button>
            <a href="#" style="color:#efd773;font-weight:bolder;font-size: 15px;margin-left: 15px" @click="reset">重置</a>
        </div>
        <!--        激活订单按钮的操作部分-->

        <!--表格显示订单数据部分-->
        <div class="">
            <el-table
                    :height="tableHeight"
                    stripe
                    highlight-current-row


                    ref="multipleTable"
                    :data="tableData"

                    style="width: 100%"



            >
                <el-table-column
                        type="index"
                        :label="$t('form_serial_number')"
                        width="50"
                       >
                </el-table-column>

                <el-table-column
                        prop="status"
                        label="任务状态"
                        width="90"
                      >
                    <template slot-scope="scope">
                        <span :class="[scope.row.status=='TS00'?'ju':(scope.row.status=='TS01'?'lv':'hei')]">
                            {{scope.row.status=='TS00'?"[待办]":(scope.row.status=='TS01'?"[已完成]":
                        (scope.row.status=='TS03'?"[已过期]":(scope.row.status=='TS04'?"[未开始]":"")))}}</span>
                    </template>
                </el-table-column>



                <el-table-column
                        prop="bmName"
                        label="分厂"
                        width="120"
                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope"></template>-->
                </el-table-column>
                <el-table-column
                        prop="cjName"
                        label="工段"
                        width="80"
                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope"></template>-->
                </el-table-column>
                <el-table-column

                        label="责任人"
                        width="120"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.dutyUserName==''?'':scope.row.dutyUserName.substring(0,scope.row.dutyUserName.length-1) }}
</span>
                    </template>


                </el-table-column>
                <el-table-column
                    prop="information"
                    label="信息点"

                    show-overflow-tooltip>
                <!--                    <template slot-scope="scope"></template>-->
                </el-table-column>
                <el-table-column
                        prop="NFC"
                        label="是否NFC"
width="80"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.isNfc==0?"否":"是"}}
                    </template>
                </el-table-column>


                <el-table-column
                    prop="content"
                    label="内容"
                    show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        width="100"
                        label="图片"
                        >
                    <template slot-scope="scope">
                        <span v-if="scope.row.imgPath==''">无</span>
<!--                        {{scope.row.imgPath==''}}-->
                        <img style="width: 60px;height: 60px;" v-if="scope.row.imgPath!==''" :src="scope.row.imgPath" @click="pic(scope.row,1)">
<!--                        <el-button type="text" @click="pic(scope.row)">查看图片</el-button>-->
                    </template>
                </el-table-column>

                <el-table-column
                        width="100"
                        prop="video"
                        label="视频"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.videoPath==''">无</span>

                        <video @click="vid(scope.row,2)" style="width: 60px;height: 60px;" v-if="scope.row.videoPath!==''" :src="scope.row.videoPath"></video>
<!--                        <el-button type="text" @click="vid(scope.row,2)">查看视频</el-button>-->
                    </template>
                </el-table-column>

                <el-table-column
                        prop="startTime"
                        label="开始时间"

                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope">{{ scope.row.isConsignShip=='HDDDA04'?'自提':'送货' }}</template>-->
                </el-table-column>
                <el-table-column
                        prop="endTime"
                        label="结束时间"

                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope">{{ scope.row.isConsignShip=='HDDDA04'?'自提':'送货' }}</template>-->
                </el-table-column>
                <el-table-column
                        prop="lruName"
                        label="提交人"
                        width="90"
                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope">{{ scope.row.isConsignShip=='HDDDA04'?'自提':'送货' }}</template>-->
                </el-table-column>
                <el-table-column
                        prop="subTime"
                        label="提交时间"

                        show-overflow-tooltip>
                    <!--                    <template slot-scope="scope">{{ scope.row.isConsignShip=='HDDDA04'?'自提':'送货' }}</template>-->
                </el-table-column>
            </el-table>

            <!--      页码-->
            <div class="block">
                <div class="pages">
                    <div class="choosepage flexother  fl">
                        <el-pagination
                                small
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="this.currentPage"
                                :page-size="this.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="this.totalNum">

                        </el-pagination>
                    </div>

                </div>
            </div>

        </div>


        <!--弹框-->

        <el-dialog
                :title="title"
                :visible.sync="task"
                :width="pttype==2?'1000px':'700px'"
                :close-on-click-modal="false"
                v-if="task"

        >
            <el-carousel @change="lbt"  v-if="pttype==1" :autoplay="false" :initial-index="0">
                <el-carousel-item v-for="(p,index) in ptlist" :key="index" >
                    <el-image  :src="p"
                               style="width: 100%;height: 100%;margin-left: 10px" :preview-src-list="ptlist"
                               :z-index="9999"
                    ></el-image>
                </el-carousel-item>
            </el-carousel>
            <div v-if="pttype==1" style="text-align: center;font-size: 19px;display: flex;align-items: center;justify-content: center;margin-top: 7px">
                <div style="color: #2b89fd">第{{nowpic}}张</div>
                <div style="margin: 2px 6px 0px 6px">/</div>
                <div>共{{ptlist.length}}张</div>
<!--                <span></span>-->
            </div>

            <video :src="ptlist[0]" style="width: 100%;height: 500px;" controls="controls" v-if="pttype==2" ></video>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clo">退出</el-button>
            </span>

        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import $ from 'jquery';
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import Video from "../../video/index";
    export default {
        name: 'TaskManage',

        components:{
            Video,
            // TaskDetail

        },
        data() {

            return {
                nowpic:1,
                task:false,
                pttype:0,
                ptlist:[],
                cjdata:[],
                baseerp: "",
                title:"",
                dialogVisible: false,// 对话框
                pvdata:[],
                types:[],
                tableData: [],
                multipleSelection: [],
                currentPage: 1,//默认显示第一页
                pageSize:10,//默认每页显示10条
                totalNum: 0, //总页数
                mid:'',
                editData:{},
                zhuangcode:[
                    {
                        status:"TS02",
                        vc_status:"全部"
                    },{
                    status:"TS00",
                    vc_status:"待办"
                },{
                    status:"TS01",
                    vc_status:"已完成"
                },{
                    status:"TS03",
                    vc_status:"已过期"
                },{
                    status:"TS04",
                    vc_status:"未开始"
                }
                ],//状态码
                tableHeight:0,
                bmdata:[],
                searchdata:{
                    status:'',
                    cid:0,
                    cjName:'',
                    gid:0,
                    startTime:'',
                    endTime:'',
                    bmName:'',
                    bc:'',
                    all:''
                }
            }
        },
        created(){

        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {

            this.$nextTick(()=>{
                this.onResize();
            })
            this.baseerp=baseerp;
            this.searchdata.status='TS02'
            let n=new Date()
            let y=n.getFullYear()
            let m=n.getMonth()+1
            let d=n.getDate()
            if(m<10){
                m='0'+m
            }
            if(d<10){
                d='0'+d
            }
            this.searchdata.startTime=y+'-'+m+'-'+d
            this.searchdata.endTime=y+'-'+m+'-'+d
            // console.log(this.searchdata)
            this.getDepartmentsList()
            //
            // this.getOrderManagerList()
        },
        computed:{

        },
        methods: {
            lbt(e){
                if(this.pttype==1){
                    this.nowpic=e+1
                    // this.title=`图片：${e+1}/${this.ptlist.length}张`
                    // this.$forceUpdate()
                }
            },
            bcclick(){
              this.getShiftClasses()
            },
            cjfilter(val){
                // console.log(val)
                if(this.searchdata.bmName!==''){
                    this.getTaskDetailList(val)
                }
            },
            statusch(val){
                this.searchdata.status=val
            },
            cjchange(val){
                this.searchdata.cjName=val
                this.searchdata.cid=val
            },
            bmchange(val){
                this.searchdata.gid=val
                if(!!this.searchdata.bmName){
                    this.getWorkshopsList()
                }
                if(!!this.searchdata.cjName){
                    this.searchdata.cjName=''

                }
                // this.editData.bzName=''
            },
            bmclear(){
                this.cjdata=[]
                this.searchdata.cjName=''
                this.searchdata.gid=0

                this.searchdata.cid=0
                // this.searchdata.gid=''
            },
            bmfilter(val){
                // this.editData.bmName=val
                this.getDepartmentsList(val)
                // console.log(this.editData.bmName)
            },

            //部门
            async getShiftClasses(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    fid:this.searchdata.gid,
                    gid:this.searchdata.cid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getShiftClasses(params);
                if (res.code == 1) {
                this.types=res.classesList
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //部门
            async getDepartmentsList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getDepartmentsList(params);
                if (res.code == 1) {
                    this.bmdata=res.departmentsList
                    if(this.bmdata.length!==0){
                        this.searchdata.bmName=this.bmdata[0].name
                        this.searchdata.gid=this.bmdata[0].id
                        if(this.searchdata.gid!==undefined){
                            this.getWorkshopsList()

                        }
                        this.getTaskDetailList()
                    }
                    // console.log(this.editData.gid==undefined)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //车间
            async getWorkshopsList(val) {
                // console.log(this.editData.bmName)

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    pid:this.searchdata.gid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getWorkshopsList(params);
                if (res.code == 1) {
                    this.cjdata=res.workshopsList
                    // if(this.cjdata.length!==0){
                        // this.searchdata.bmName=this.bmdata[0].name
                        // this.searchdata.gid=this.bmdata[0].id
                    //     if(this.searchdata.gid!==undefined){
                    //         this.getWorkshopsList()
                    //
                    //     }
                    //     this.getTaskDetailList()
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //列表
            async getTaskDetailList(val) {
                // console.log(this.editData.bmName)

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    status:this.searchdata.status,
                    startTime:this.searchdata.startTime,
                    endTime:this.searchdata.endTime,
                    fid:this.searchdata.gid,
                    gid:this.searchdata.cid,
                    search:this.searchdata.all,
                    dbTime:this.searchdata.bc,
                    pageNum:this.currentPage,
                    pageSize:this.pageSize
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getTaskDetailList(params);
                if (res.code == 1) {
                    this.tableData=res.tasksList
                    this.totalNum=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            pic(val,i){
                this.title="图片",
                    this.nowpic=1
                    // console.log(val)
                this.editData=val
                this.pttype=i

                this.getTaskDetailFileList(i)
                // this.editData=val,
            },
            vid(val,i){
                this.title="视频",
                this.editData=val,
                    this.pttype=i
                    this.getTaskDetailFileList(i)

                // this.task=true
            },
            ...mapActions(["getCurrentMenuId"]),


            heightAuto(){
                this.$nextTick(()=>{
                    this.tableHeight = window.innerHeight -  300
                })
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                this.tableHeight=n.h-130
            },
            fun(val){
                return Number(val).toFixed(2)
            },
            clo(){
            this.task=false
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getTaskDetailList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getTaskDetailList()
            },
            //图片视频
            async getTaskDetailFileList(i){
                this.ptlist=[]
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    id:this.editData.id,
                    type:this.pttype
                };
                let res=await API.getTaskDetailFileList(param)
                if(res.code==1){
                    this.pvdata=res.filesList
                    let add=[]
                    if(i==1){
                        this.pvdata.forEach(item=>{
                            add.push(item.path)
                        })
                        this.ptlist=add
                        // this.title=`图片：1/${this.ptlist.length}张`
                    }else{
                        this.pvdata.forEach(item=>{
                            add.push(item.path)
                        })
                        this.ptlist=add
                        this.title=`视频`

                    }
                    this.task=true
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },


            find(){
                if(!this.searchdata.status){
                    this.$message.error('请选择任务状态')
                }else {
                    this.currentPage=1

                    this.getTaskDetailList();


                }
                // console.log(this.searchdata)
            },
            reset(){
                this.searchdata={
                    status:'TS02',
                    cid:0,
                    cjName:'',
                    gid:0,
                    startTime:'',
                    endTime:'',
                    bmName:'',
                    bc:'',
                    all:''
                }
                if(this.bmdata.length!==0){
                    this.searchdata.bmName=this.bmdata[0].name
                    this.searchdata.gid=this.bmdata[0].id
                }

            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/.el-table td{
        padding: 9px 0px 3px 0px;
    }
    /deep/.el-dialog__close{
        color: black !important;
    }
    /deep/.el-carousel__arrow{
        background-color: #999999 !important;
    }
    /deep/.el-dialog__title{
        color: black !important;
    }
    .AllOrder{
        background-color: #ffffff;
        height: 755px;
        .orderID{
            height: 400px;
            width: 90%;
            border: 1px solid #e0e0e0;

        }
        /deep/.el-dialog--center .el-dialog__header{
            display: flex;
            justify-content: center;

        }

        .title{
            display: flex;
            padding: 10px 10px;
            /*justify-content: center;*/
            align-items: center;
            vertical-align: center;
            .input-with-select .el-input-group__prepend {
                background-color: #fff;
            }
            .titlew{
                padding: 0 10px;
            }

        }
        .contentcaozuo{
            display: flex;
            padding: 10px 10px 0 10px;
            /*justify-content: center;*/
            align-items: center;
            vertical-align: center;
        }
        .main{
            /*display: flex;*/
            /*padding: 10px 10px;*/
            /*justify-content: center;*/
            align-items: center;
            vertical-align: center;

        }
        /deep/.el-table .disabledCheck .cell .el-checkbox__inner{
            display: none !important;
        }
        .flex {
            display: flex;
            flex-flow: wrap;
            justify-content: flex-start;
            align-items: center;
        }
        .lv{
            color: #3cb44b;

        }
        .ju{
            color: #f08c00;
        }
        .hei{
            color: #808080;

        }
        .flexother {
            display: flex;
            flex-flow: wrap;
            justify-content: flex-end;
            align-items: center;
        }

        .fl{
            float: right;
            .el-button--primary{
                color: #efd773;
                background-color:white;
                border: 0;
                text-align: center;
                padding: 0;
                height: 28px;
                width: 46px;
                margin:12px 0 0 10px;
            }
        }

        .fr{
            float:right;
        }

        .cl{
            clear: both;
        }

        /*.mrt20{*/
        /*    margin-top: 20px;*/
        /*}*/
        .mrl20{
            margin-left: 20px;
        }
        .mrb20{
            margin-right: 20px;
        }
        .mrr20{
            margin-right: 20px;
        }

        .chooseheader{
            width:100%;
        }

        .choosepage{
            width:90%
        }




    }
</style>
